<template>
	<div class="flex">
		<div
			:class="[
				'won-tag-light-gray size-6 rounded-l-md border-r border-won-gray-light',
				'flex cursor-pointer items-center justify-center select-none',
			]"
			@click="builderStyle.zoomOut"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="won-color-gray size-4 stroke-2"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M19.5 12h-15"
				/>
			</svg>
		</div>

		<div
			:class="[
				'flex h-6 w-[46px] cursor-pointer items-center',
				'won-tag-light-gray justify-center select-none',
			]"
			@click="builderStyle.resetZoom"
		>
			<div class="won-color-gray text-sm">{{ zoom }}%</div>
		</div>

		<div
			:class="[
				'won-tag-light-gray size-6 rounded-r-md border-l border-won-gray-light',
				'flex cursor-pointer items-center justify-center select-none',
			]"
			@click="builderStyle.zoomIn"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="won-color-gray size-4 stroke-2"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M12 4.5v15m7.5-7.5h-15"
				/>
			</svg>
		</div>

	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useBuilderStyles } from '../../store/builder-style.store';

const builderStyle = useBuilderStyles();
const { zoom } = storeToRefs(builderStyle);
</script>
